<template>
  <div class="graph-wrapper" ref="wrap">
    <div ref="knowledgeGraph" class="knowledge-graph"></div>
    <div class="btn-wrap" v-show="!chat.isFull">
      <svg ref="svgRef" t="1741750015662" class="icon screen-icon" :class="isFull ? 'full' : ''" @click="handleFull"
        viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6479" width="200" height="200">
        <path
          d="M368.896 192H224a32 32 0 0 0-32 32v137.888a32 32 0 0 0 64 0V256h112.896a32 32 0 0 0 0-64zM784.864 192H640a32 32 0 1 0 0 64h112.864v105.888a32 32 0 1 0 64 0V224a32 32 0 0 0-32-32zM368.896 777.92H256V672a32 32 0 1 0-64 0v137.92a32 32 0 0 0 32 32h144.896a32 32 0 1 0 0-64zM784.864 640a32 32 0 0 0-32 32v105.92H640a32 32 0 1 0 0 64h144.864a32 32 0 0 0 32-32V672a32 32 0 0 0-32-32z"
          fill="#020202" p-id="6480"></path>
        <path
          d="M912 48h-800c-35.296 0-64 28.704-64 64v800c0 35.296 28.704 64 64 64h800c35.296 0 64-28.704 64-64v-800c0-35.296-28.704-64-64-64z m-800 864v-800h800l0.064 800H112z"
          fill="#020202" p-id="6481"></path>
      </svg>
    </div>
    <!-- <ImageEnlarge :src="enlargeSrc" :layer="layer" ref="enlarge" v-if="isModalShow" @handleModal="handleModal">

    </ImageEnlarge> -->
  </div>

</template>

<script>
import * as D3 from "d3";
import chatMixin from "@/mixin/chat.js";
import store from "@/store/index";
import md from "@/utils/markdown/md";
import ImageEnlarge from "@/components/ImageEnlarge.vue"

import { nanoid } from "nanoid";
// import "@/utils/mathJax.js";

import { getImageSrcFromHtml } from '@/utils/tool'
import { createAutoMsg } from '@/utils/chat/autoMsg'
import { interpolateRainbow, schemeTableau10 } from "d3-scale-chromatic";
import { mapState } from "vuex";

var modalLayer = 0

const Node = {
  width: 600,
  height: 60,
  background: "rgb(0, 139, 248)",
  r: 8,
  color: "inherit",
};
const TransitionDuration = 500;
const dpr = 1
// console.log("===dbr====", 1/dpr)
export default {
  data() {
    return {
      isModalShow: false,
      isFull: false,
      layer: 3000,
      enlargeSrc: "",
      originSize: {
        svgWidth: '',
        svgHeight: '',
        rootWidth: '',
        rootHeight: '',

      },
      data: {
        resizeObserver: null,// 新增：用于监听父组件尺寸变化
        zoom: {},
        dataOption: {},
        kgId: "",

      },
    };
  },
  components: {
    ImageEnlarge,
  },
  props: ["chat", "sessionId"],
  computed: {
    ...mapState(["robotId"])
  },
  mixins: [chatMixin],
  created() { },
  mounted() {
    this.dataOption = this.chat.paintData;
    this.kgId = this.chat.kgId;
    // this.isFull = this.chat.isFull ? true : false;
    this.initSvg();
    this.initResizeObserver(); // 新增：初始化尺寸变化监听器

  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect(); // 新增：在组件销毁前断开监听器
    }
  },

  methods: {
    handleFull() {
      // 修复全屏切换后的尺寸同步
      this.isFull = !this.isFull;
      this.$nextTick(() => {
        this.draw(true);
      });
    },

    closeAllModal() {
      let eles = document.querySelectorAll('.el-image-viewer__wrapper');
      eles && eles.forEach((ele) => {
        ele.style.display = "none"

      })

    },
    handleModal() {
      // this.isModalShow = !this.isModalShow
      this.$emit("handleModal")
    },
    imagePreview(d) {
      this.layer += ++modalLayer;
      this.isModalShow = true;
      console.log(d.data.image)
      this.enlargeSrc = getImageSrcFromHtml(md.render(d.data.image))
      this.$emit("handleGraphImagePreview", this.enlargeSrc)

    },



    initSvg() {
      this.$svg = D3.create("svg");
      this.$svg.attr("width", '100%');
      this.$svg.attr("height", '100%');
      this.$svg.attr("class", 'graph-svg');

      const container = this.$refs.knowledgeGraph;

      const containerWidth = container.clientWidth;

      const containerHeight = container.clientHeight;
      // 根据容器尺寸动态居中
      const viewBoxX = -containerWidth / 2;
      const viewBoxY = -containerHeight / 2;
      this.$svg.attr("viewBox", `${viewBoxX} ${viewBoxY} ${containerWidth} ${containerHeight}`)
        .on("dblclick", () => this.resetView());

      this.$wrap = this.$svg.append("g");


      this.zoom = D3.zoom()
        .scaleExtent([0.8, 10]) // 设置最小缩放比例为 0.5，最大缩放比例为 2
      if (this.chat.large) {
        this.zoom.scaleExtent([2, 20])
      }
      this.zoom.translateExtent([[-Infinity, -Infinity], [Infinity, Infinity]]) // 完全禁用平移约束

        .on("zoom", (event) => {

          const transform = D3.event.transform;


          // 动态约束平移范围（核心修正）
          const constrainedTransform = this.constrainTransform(transform);

          this.$wrap.attr("transform", constrainedTransform);

        })
        .on("start", () => {
          // 触摸开始时的处理逻辑
        })
        .on("end", () => {
          // 触摸结束时的处理逻辑
        });
      this.$svg.call(this.zoom)

      this.$linkGroup = this.$wrap.append("g").attr("class", "link-group");
      this.$nodeGroup = this.$wrap.append("g").attr("class", "node-group");

      this.$refs.knowledgeGraph.appendChild(this.$svg.node());

      this.tree = D3.tree().nodeSize([Node.height * 1.5, Node.width * 0.8]).separation(this.getNodeSeparation)// 固定布局角度和半径
      this.data = D3.hierarchy(this.dataOption);
      // 默认折叠非直接子节点
      this.data.descendants().forEach((node) => {
        node.id = nanoid();
        if (node.depth >= 1) {
          // 折叠第三层及以下节点
          if (node.children) {
            node.isFold = true;
            node._children = node.children;
            node.children = null;
          }
        }
      });
      this.draw(true);

    },
    // 约束缩放平移范围，防止内容消失
    constrainTransform(transform) {
      const svg = this.$svg.node();
      const content = this.$wrap.node();

      // 获取实际内容边界
      const contentBounds = content.getBBox();
      const svgWidth = svg.clientWidth;
      const svgHeight = svg.clientHeight;
      // 计算有效平移范围（需考虑缩放比例）
      const scaledWidth = contentBounds.width * transform.k;
      const scaledHeight = contentBounds.height * transform.k;
      const maxX = Math.max(0, (scaledWidth - svgWidth) / 2);
      const minX = -maxX;
      const maxY = Math.max(0, (scaledHeight - svgHeight) / 2);
      const minY = -maxY;

      // 放宽约束，允许在内容小于视口时自由移动
      const allowPanX = scaledWidth > svgWidth;
      const allowPanY = scaledHeight > svgHeight;
      transform.x = allowPanX ? Math.max(minX, Math.min(transform.x, maxX)) : transform.x;
      transform.y = allowPanY ? Math.max(minY, Math.min(transform.y, maxY)) : transform.y;

      return transform;
    },


    // 计算rect宽度
    getWidth(d) {
      if (!d || !d.data || !d.data.name) return 0
      if (d.data.name.length <= 4) {
        if (d.data.name.length === 1) {
          return 60
        }
        return d.data.name.length * 40 * dpr;
      }
      if (d.data.name.length > 20) {
        return 300 * dpr
      }
      return d.data.name.length * 20 + 120;
    },
    // 计算 description 长度并设置节点间距
    getNodeSeparation(a, b) {
      let aDescLength = a.data.description ? a.data.description.length : 0;
      let bDescLength = b.data.description ? b.data.description.length : 0;
      // 根据 description 长度调整间距
      const additionalSeparation = Math.max(aDescLength, bDescLength) * 0.1 * dpr; // 增大间距系数
      const baseSeparation = 1.2;
      if (a.depth === b.depth) {
        // 同一层次的节点，水平间距
        return baseSeparation + additionalSeparation / 5; // 增大水平间距倍数
      } else {
        // 不同层次的节点，垂直间距
        return baseSeparation; // 增大垂直间距倍数
      }
    },

    /* 精准垂直居中逻辑 */
    centerRootVertically(rootNode) {
      if (rootNode.children && rootNode.children.length > 0) {
        // 直接设置根节点在画布中央
        rootNode.x = 0;
        rootNode.y = 0;
      }
    },
    /* 生成汇聚式路径 */
    generateConsolidatedPath(d) {
      let sourceX = d.source.x;
      // 根节点连接点
      if (sourceX < 0) {
        sourceX = sourceX - this.getWidth(d.source) / 2 - 30
        // if(d.source.data.image) {
        //   sourceX = sourceX - 60;
        // }
      } else if (sourceX > 0) {
        sourceX = sourceX + this.getWidth(d.source) / 2 + 30
      } else {

      }


      const sourceY = d.source.y + 18;
      // 子节点连接点
      let targetX = d.target.x;

      if (targetX > 0) {
        if (d.source.data.image) {
          sourceX = sourceX + 55;
          if (sourceX === 55) {
            sourceX += this.getWidth(d.source) / 2

          }
        }
      } else if (targetX < 0) {
        if (d.source.data.image) {
          if (sourceX === 0) {

          } else {
            sourceX = sourceX - 55;
          }

        }
      }
      // 修改targetY计算
      const targetY = d.target.y + 20;
      // 确保路径方向从左到右
      if (sourceX > targetX) {
        // 添加曲线控制，让路径更平滑避开文字区域
        return `M${targetX},${targetY} C${(targetX + sourceX) / 2},${targetY} ${(targetX + sourceX) / 2},${sourceY} ${sourceX},${sourceY}`;
      }
      // 创建水平分支连接，添加曲线控制
      return `M${sourceX},${sourceY} C${(targetX + sourceX) / 2},${sourceY} ${(targetX + sourceX) / 2},${targetY} ${targetX},${targetY}`;

    },

    /* 动态调整视口 */
    updateViewport(nodes) {

      // 计算坐标边界（包含所有节点）
      const xExtent = D3.extent(nodes, (d) => d.x)
      const yExtent = D3.extent(nodes, (d) => d.y)

      // 计算内容宽高
      const contentWidth = xExtent[1] - xExtent[0]
      // 添加高度计算
      const maxHeight = D3.max(nodes, d => d.data.dynamicHeight || Node.height);
      // 高度计算
      const contentHeight = yExtent[1] - yExtent[0] + maxHeight * 0.4;
      const deviceWidth = window.innerWidth;
      // 添加动态padding（根据树深度调整）
      let padding;
      if (deviceWidth < 768) {
        padding = 20;
      } else if (deviceWidth < 1024) {
        padding = 100;
      } else {
        padding = 150;
      }

      const viewWidth = contentWidth + padding * 2.5
      const viewHeight = contentHeight + padding * 1

      // 计算中心点偏移
      const centerX = (xExtent[0] + xExtent[1]) / 2
      const centerY = (yExtent[0] + yExtent[1]) / 2

      // 设置视口以内容中心点为中心
      this.$svg
        .transition()
        .duration(TransitionDuration)
        .attr(
          "viewBox",
          `${centerX - viewWidth / 2} ${centerY - viewHeight / 2} ${viewWidth} ${viewHeight}`
        )


    },
    /* draw */

    /**
     * @name 绘制
     * @param {Boolean} init 第一次
     */
    draw(init = false) {
      let root = this.tree(this.data);
      root.x = 0
      root.y = 0
      let nodes = root.descendants();
      this.nodes = nodes;
      nodes.forEach((a) => {
        [a.x, a.y] = [a.y, a.x];
        // 测试用
        // a.data.image = "![logo.png](images/logo.png)"
        // if (a.data.image) {
        //   a.data.image = getImageSrcFromHtml(md.render(a.data.image))
        // }
        // console.log(a)
        // a.data.name = md.render(a.data.name)
        // if(a.data.description)
        // a.data.description =   md.render(a.data.description)
      }); // 需要旋转90度
      let kids = root.children;
      if (kids.length < 3) {
        let middleOffset = (kids[0].y + kids[kids.length - 1].y) / 2
        kids.forEach((a) => {
          a.descendants().forEach((b) => {
            b.y -= middleOffset;
          });
        });
      } else {
        let splitIndex = Math.ceil(kids.length / 2);

        let left = kids.slice(0, splitIndex); // 左侧节点
        // 右分支：后半部分子节点
        let right = kids.slice(splitIndex);

        let leftMiddleOffset = (left[0].y + left[left.length - 1].y) / 2;
        left.forEach((a) => {
          a.descendants().forEach((b) => {
            // 左分支节点x坐标取反并根据节点宽度调整
            b.x = -b.x - this.getWidth(b) / 2; // 左对齐
            b.y -= leftMiddleOffset;
          });
        });
        let rightMiddleOffset = (right[0].y + right[right.length - 1].y) / 2;
        right.forEach((a) => {
          a.descendants().forEach((b) => {
            // 右分支节点x坐标根据节点宽度调整
            b.x = b.x + this.getWidth(b) / 2; // 右对齐
            b.y -= rightMiddleOffset;
          });
        });
      }
      setTimeout(() => {
        this.updateViewport(nodes);
      }, 100); // 等待渲染完成

      let _this = this;
      let $nodes = this.$nodeGroup
        .selectAll(".node")
        .data(nodes, (d) => d.id)
        .join(
          (enter) => {
            let $gs = enter.append("g");
            //展开折叠按钮
            $gs
              .append("text")
              .attr("fill", "yellowgreen")
              .attr("class", "toggle")
              .attr("dy", 30)
              .attr("x", (d) => {
                if (d.depth === 0) return;
                // 根据节点的宽度动态计算按钮位置
                const rectWidth = this.getWidth(d);
                if (d.x === 0 && d.data.image) {
                  return rectWidth / 2 + 75
                } else if (d.x === 0) {
                  return rectWidth / 2 + 10
                } else if (d.x > root.x) {
                  if (d.data.image) {
                    return rectWidth / 2 + 65
                  } else {
                    return rectWidth / 2 + 3
                  }
                } else {
                  if (d.data.image) {
                    return -rectWidth / 2 - 80
                  } else {
                    return -rectWidth / 2 - 22
                  }
                }
              })

              .style("cursor", "pointer")
              .style("font-weight", "bolder") // 可选：加粗图标
              .style("font-size", "34PX") // 可选：调整图标大小
              .text((d) => {
                if (d.depth === 0) return
                // 合并条件判断：展开时显示"-"，折叠时显示"+"
                if (d.children || d._children) {
                  return d.isFold ? "+" : "-";
                }

              })
              .on("click", this.toggleNode);
            // 渲染公式节点名称
            $gs
              .append("foreignObject")
              .attr("x", (d) => -this.getWidth(d) / 2)
              .attr("y", -Node.height * 0.62) // 调整初始位置
              .attr("width", (d) => this.getWidth(d))
              .attr("height", "150") // 改为自动高度
              .append("xhtml:div")

              .style("max-width", (d) => this.getWidth(d) + "PX") // 限制最大宽度
              .style("word-break", "break-word") // 允许单词断行
              .html((d) => md.render(d.data.name))
              .style("pointer-events", "auto") // 防止事件被阻挡

              .on("click", function (d) { // 直接在div上绑定事件
                // event.stopPropagation(); // 阻止事件冒泡到svg层
                _this.getSection(d)
                // 这里可以访问正确的d参数
              })
              .style("text-align", "center")
              .style("font-size", "22PX")
              .style("color", Node.color)
              .selectAll("p") // 选择所有生成的 p 标签
              .attr("class", 'node-name')
              .each(function (d) {
                console.log(d)
                // 保存数据到div元素
                D3.select(this).datum(d);

                // 现在处理p元素
                D3.select(this)
                  .selectAll("p")
                  .data([d]) // 显式绑定数据
                  .attr("class", "node-name")
                  .each(function (d, i) {
                    // 这里d将正确传递
                    d.data.nameHeight = this.getBoundingClientRect().height;
                    console.log("数据:", d.data.name, "高度:", d.data.nameHeight);
                  });
              });
            $gs
              .filter((d) => {
                return d.data && d.data.description && d.data.description.trim() !== ''
              })
              .append("foreignObject")

              // .attr("y", d => {
              //   console.log(d.data.dynamicHeight)
              //   if (d.data.name.length >= 17) {
              //     return Node * 1.2
              //   } else {
              //     return Node.height * 0.56
              //   }
              // })

              .attr("y", d => {
                return (d.data.nameHeight || Node.height * 0.56);
              })
              .attr("x", d => {

                // 新增逻辑：根据节点是否在根节点左侧调整x坐标
                const isLeftNode = d.x < root.x; // root.x为根节点的x坐标
                const nodeWidth = this.getWidth(d); // 获取节点宽度

                if (isLeftNode) {
                  // 左侧节点：描述文字右对齐，x坐标为节点右侧边缘
                  return - Math.max(nodeWidth / 2, 150);

                } else {
                  // 右侧节点：保持原逻辑（如需调整可一并修改）
                  return -nodeWidth / 2;
                }

              })
              .attr("width", d => Math.max(this.getWidth(d), 300))
              .attr("height", 500)
              .append("xhtml:div")
              .attr("class", "desc-text")
              .html((d) => {
                return md.render(d.data.description ? d.data.description : "")
              })
              .style("text-align", "left")
              .style("padding", "5px"); // 增加内边距提升可读性

            // 绘制图片
            $gs
              .append("image")
              .attr("xlink:href", (d) => getImageSrcFromHtml(md.render(d.data.image)))
              .attr("x", d => {
                let isLeftNode = d.x < root.x
                if (isLeftNode) {
                  return - this.getWidth(d) / 2 - 50
                } else {

                  return -this.getWidth(d) / 2 + this.getWidth(d) + 10
                }

              })
              .attr("y", -8)
              .attr("width", 50)
              .attr("height", 50)
              .attr("display", d => {
                if (d.data.image) {
                  return ""
                } else {
                  return "none"
                }
              })
              .on("click", this.imagePreview);;
            return $gs;
          },
          (update) => update,
          (exit) => {
            exit
              .transition()
              .duration(init ? 0 : TransitionDuration)
              .attr("opacity", 0)
              .attr(
                "transform",
                (d) => `translate(${d.parent.x},${d.parent.y})`
              )
              .remove();
          }
        )
        .attr("class", "node");

      $nodes
        .filter((a) => a.originX !== undefined && a.originY !== undefined)
        .attr("opacity", 0)
        .attr("width", (d) => this.getWidth(d))
        .attr("transform", (d) => {
          let x, y;
          if (d.originX) {
            x = d.originX;
            delete d.originX;
          } else {
            x = d.x;
          }
          if (d.originY) {
            y = d.originY;
            delete d.originY;
          } else {
            y = d.y;
          }

          return `translate(${x}, ${y})`;
        });

      $nodes
        .transition()
        .duration(init ? 0 : TransitionDuration)
        .attr("opacity", 1)
        .attr("transform", (d) => `translate(${d.x}, ${d.y})`)
        .each((d, i, nodes) => {
          // 节点渲染完成后计算高度
          this.updateNodeHeight(d, nodes[i]);
        });

      let links = root.links();

      const lineColors = [
        "#9CA3AF", // 高级灰
        "#A78BFA", // 柔紫
        "#60A5FA", // 雾蓝
        "#34D399", // 薄荷绿
        "#FBBF24"  // 琥珀黄
      ];
      // 绘制链接路径
      const linkUpdate = this.$linkGroup
        .selectAll(".link")
        .data(links, d => nanoid());

      // 进入处理
      const linkEnter = linkUpdate.enter()
        .append("path")
        .attr("class", "link")
        .attr("id", d => {
          return nanoid()
        }) // 动态ID
        .attr("fill", "none")
        .style("stroke", (d, i) => interpolateRainbow(i / 100))

        .attr("d", d => this.generateConsolidatedPath(d, true));

      // 更新处理
      linkUpdate.merge(linkEnter)
        .transition()
        .duration(init ? 0 : TransitionDuration)
        .attr("d", d => this.generateConsolidatedPath(d));

      // 退出处理
      linkUpdate.exit().remove();

      this.$nextTick(() => {
        this.updateNodeHeights();
        this.adjustDescriptions();
      });

    },
    updateNodeHeights() {
      this.$nodeGroup.selectAll('.node-name').each(function () {
        const d = D3.select(this).datum();
        if (d) {
          d.data.nameHeight = this.getBoundingClientRect().height;
        }
      });
    },

    adjustDescriptions() {
      this.$nodeGroup.selectAll('.desc-text').each(function () {
        const d = D3.select(this).datum();
        if (d && d.data.nameHeight) {
          const foreignObject = this.closest('foreignObject');
          if (foreignObject) {
            foreignObject.setAttribute(
              'y',
              (d.data.nameHeight || Node.height * 0.62) + 15
            );
          }
        }
      });
    },
    // 添加动态高度计算
    updateNodeHeight(d, element) {
      const computedHeight = element.getBoundingClientRect().height;
      d.data.dynamicHeight = Math.max(computedHeight, Node.height);
    },
    // 新增：初始化尺寸变化监听器
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        // this.onResize();
      });
      this.resizeObserver.observe(this.$refs.wrap);
    },

    // 重置缩放和平移
    resetView() {
      const initialTransform = D3.zoomIdentity
        .translate(0, 0)
        .scale(1);

      this.$svg.transition()
        .duration(500)
        .call(this.zoom.transform, initialTransform);

      // 可选：重新居中内容
      this.updateViewport(this.data.descendants());
    },
    /**
     * @name 处理结点点击
     * @param {Object} ev 事件
     * @param {Object} d 数据
     */
    // 展开折叠
    toggleNode(d) {
      d.isFold = !d.isFold
      this.$nodeGroup.selectAll(".node .toggle")
        .text((d) => {
          if (d.depth === 0) return;
          if (d.children || d._children) {
            return d.isFold ? "+" : "-";
          }
        });

      if (d.depth !== 0) {
        if (d.children) {
          d._children = d.children;
          d.children = undefined;
        } else if (d._children) {
          d._children.forEach(a => {
            a.x0 = d.x;  // 使用x0/y0作为过渡起点
            a.y0 = d.y;
          });
          d.children = d._children;
          d._children = undefined;
        }
        this.draw();
      } else {
      }
    },
    // 点击节点发送MathChat请求
    async getSection(d) {
      // 首屏知识图谱不获取报告
      if (this.chat.isFull) return;
      // 非首页需要展示报告
      if (this.isFull) {
        this.isFull = !this.isFull;
        this.draw(true)
      }
      let text = d.data.name;
      let robotId = this.robotId
      let myMsg = {
        type: "my",
        fileList: [],
        avatar: require("@/assets/image/chat/humen.svg"),
      };
      myMsg.msg = text;

      let electricaiMsg = createAutoMsg(
        this.robots.knowledgeGraph.avatar,
        this.$delete
      );
      electricaiMsg.type = "graphCollect"
      electricaiMsg.params = {
        robotId,
        sessionId: this.sessionId,
        text,
        fileList: [],
        kgid: this.kgId,
        clickName: text
      };

      // store.commit("UPDATE_MESSAGE", {
      //   robotId,
      //   key: this.sessionId,
      //   msg: myMsg,
      // });
      // store.commit("UPDATE_MESSAGE", {
      //   robotId,
      //   key: this.sessionId,
      //   msg: electricaiMsg,
      // });
      myMsg.sessionId = this.sessionId
      myMsg.robotId = robotId
      electricaiMsg.sessionId = this.sessionId
      electricaiMsg.robotId = robotId
      await this.$store.dispatch('addMessageToConversation', {
        message: myMsg,
      });
      await this.$store.dispatch('addMessageToConversation', {
        message: electricaiMsg,
      });
      let paramsObj = {
        text,
        fileList: [],
        sessionId: this.sessionId,
        robotId,
        answerUrl: '/api/kgNode2report',
        aiContent: electricaiMsg,
        clickName: text,
        kgid: this.kgId
      };
      this.robots["graphCollect"].getStreamAnswer(paramsObj);
    },

  },
};
</script>

<style lang="scss" scoped>
.graph-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;

  .top-section {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;

    i {
      font-size: 40PX !important;
    }
  }

  &:has(.full) {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw !important;
    height: 100% !important;
    background-color: var(--markdown-bg-color);
    z-index: 1001;

    .graph-svg {
      width: 100% !important;
      height: 100% !important;
    }


    .knowledge-graph {
      width: 100%;
      height: 96%;

    }
  }
}

.knowledge-graph {
  width: 100%;
  height: 60vh;

}

// 知识图谱控制svg极其包裹的宽高

.svg-wrap {
  /* 定义 SVG 包裹容器的类 */
  /* 这里设置高度，减去 80PX */
  height: calc(100% - 80PX);

}

.graph-svg-custom {
  /* 设置宽度和高度 */
  width: 100%;
  height: calc(100% - 80PX);

}

.btn-wrap {
  text-align: center;
  padding-top: 10PX;
  padding-bottom: 10PX;
  height: 20PX;

  svg {
    height: 20PX;
    width: 20PX;
    background-color: var(--markdown-bg-color);
  }

}

.node {
  width: max-content !important;


}


rect {
  height: max-content !important;
}


.link {
  stroke: #999;
  /* 连接线颜色 */
  stroke-width: 2;
  /* 连接线宽度 */
  stroke-opacity: 0.8;
  /* 连接线透明度 */
  fill: none;

}

svg {
  transition: all 1s ease-in-out;
}

.btn-wrap {
  margin: 0 auto;

  .screen-icon {
    cursor: pointer;
    width: 20PX;

    path {
      fill: rgb(150, 150, 201);
    }
  }
}

.toggle {
  transform: translate(0, -8PX) !important;
  /* 移除水平位移 */
  font-size: 24PX !important;
  fill: #fff !important;
  text-shadow: 0 2PX 4PX rgba(0, 0, 0, 0.2);
  z-index: 100;

  /* 添加悬停效果 */
  &:hover {
    filter: brightness(1.2);
    transform: translate(0, -8PX) scale(1.1);
  }
}

::v-deep li:has(.katex) {
  line-height: 1.5 !important;
}

::v-deep p:has(.katex) {
  line-height: 1.5 !important;
}

.katex {
  display: inline-block;
  max-width: 100%;
  overflow-x: auto;
  white-space: normal !important;

}

.katex-html {
  white-space: normal !important;
  text-align: center;

}


.desc-text {
  margin-top: 8px !important;
  max-height: 180PX;
  padding: 5PX;
  font-size: 14PX !important;
  overflow: visible;
  line-height: 1.5;
  color: #666;

  ::v-deep p {
    text-align: left !important;
    margin: 0;
    margin-top: 5px;
  }




}

::v-deep foreignObject div {
  line-height: 1.5;
  padding: 8PX;

  overflow: visible;
  color: #999;
  font-weight: 550;
  font-size: 14PX;

  ::v-deep p {
    overflow: visible;
  }
}

::v-deep .node-name {
  padding: 8PX 5PX;
  border-radius: 10PX;
  background-color: #ececff;
  border: 2PX solid #ccf;
  cursor: pointer;
  // color: var(--txt-default-color);
  color: #1a2029;
  font-weight: 500;

  div {
    height: auto;
  }



}

::v-deep image {
  cursor: pointer;
}

@media (max-width: 1024px) {

  .graph-wrapper {
    // width: 80%;
    width: fix-content;
  }

  .knowledge-graph {
    height: 28vh;
    aria-hidden: false !important;
    padding: 12px 0;
    /* 增加点击热区 */
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    /* 移除点击高光 */

    @media (hover: none) {
      /* 移动端专属优化 */
      font-size: 16px;
      /* 增加可点击区域 */
      min-height: 48px;
      /* Material Design 推荐最小点击尺寸 */
    }
  }

  ::v-deep foreignObject div {
    line-height: 1.5;
    padding: 8PX;

    overflow: visible;
    color: #999;
    font-weight: 550;
    font-size: 10px;

    ::v-deep p {
      overflow: visible;
    }
  }


  /* 修复 foreignObject 内文本流 */
  .desc-text {
    /* 强制统一行高 */
    line-height: 1.6em;
    /* 避免文字溢出 */
    overflow-wrap: break-word;


  }

  ::v-deep .katex {

    .katex-mathml,
    .katex-html {
      // position: absolute;
      // border: 1px solid red !important;
      /* 关键：统一垂直对齐为文本底部，解决基线错位 */
      vertical-align: bottom !important;
      /* 强制公式容器与普通文本行高一致 */
      line-height: 1.5em !important;
      /* 允许公式内单词断行（移动端必备） */
      white-space: normal !important;
      word-break: break-word !important;
      /* 移除不必要的外边距 */
      margin: 0 !important;
      padding: 0 !important;
      font-size: 10px !important;
    }


  }


}
</style>